import { render, staticRenderFns } from "./BaseEditableFieldLabel.vue?vue&type=template&id=77c6c52c"
import script from "./BaseEditableFieldLabel.vue?vue&type=script&lang=js"
export * from "./BaseEditableFieldLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports